import React, { useMemo } from 'react';
import noop from 'lodash/noop';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { useTextSearchInputClause } from '@atlassian/jira-jql-utils/src/utils/text-search-input-clause/use-text-search-input-clause.tsx';
import {
	useAST,
	useTextSearchInputClause as useTextSearchInputClauseOld,
} from '../../../../controllers/ast/index.tsx';
import TextFieldType from '../../../../controllers/field-type/text/index.tsx';
import { removeSurroundingQuotes } from '../../../../utils/remove-surrounding-quotes.tsx';
import messages from '../../../messages.tsx';
import TextField from '../../text-field/index.tsx';
import { getTextSearchInputField } from '../../../constants.tsx';

type Props = {
	placeholder?: string;
};

export const TextSearchInputLoading = ({ placeholder }: Props): React.JSX.Element => {
	const intl = useIntl();
	const [ast] = useAST();

	const [textSearchInputClauseOld] = useTextSearchInputClauseOld();
	const textSearchInputClauseNew = useTextSearchInputClause(ast, getTextSearchInputField());

	const textSearchInputClause = fg('shplxi_628_cleanup')
		? textSearchInputClauseNew
		: textSearchInputClauseOld;

	const value = useMemo(
		() => removeSurroundingQuotes(TextFieldType.value(textSearchInputClause) || ''),
		[textSearchInputClause],
	);

	return (
		<TextField
			label={
				placeholder !== undefined
					? placeholder
					: intl.formatMessage(
							expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
								? messages.refinementSearchIssueTermRefresh
								: messages.refinementSearch,
						)
			}
			value={value}
			onChange={noop}
			isDisabled
		/>
	);
};
